<a [routerLink]="['/product',data.no]">
  <app-product-cover [data]="data"></app-product-cover>

  @if (showTitle) {
  <span class="name">{{data.name}}</span>
  }
  <div class="tags">
    @if (isBestSellers) {
    <span>Best Sellers</span>
    } @if (isNewArrivals) {
    <span>New</span>
    }
  </div>
</a>
<!-- <span app-product-price [data]="data"></span> -->